<template>
  <div>profile page will go here</div>
</template>

<script>
  export default {
    name: 'Profile',
    routeConfig: {
      name: "profile", path: "/profile"
    },
    metaInfo: {
      title: "Profile"
    }
  }
</script>



// WEBPACK FOOTER //
// src/routes/Profile/index.vue